<mat-icon svgIcon="card-details"></mat-icon><span [innerHTML]="monitor.details.system"></span>
